<template>
<div>
  <div
    id="cashierOrderVipRecharge"
    v-loading="loading"
    element-loading-text="等待付款成功"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    style="height:100%;width:100%"
    v-show="pageType == 1"
  >
    <div class="rc-title flex-between alignCenter">
      <div class="center back" @click="back(false)">
        <span style="margin-right:7px;">
          <img src="../../assets/icon/turnLeft.png" alt />
        </span>会员充值
      </div>
      <div class="back" @click="back(true)" style="color: gray;font-size: 20px;">X</div>
    </div>
    <div class="content">
      <div class="warp row">
        <div class="key alignCenter">会员号码</div>
        <div class="value alignCenter">{{vipList.phoneNum}}</div>
      </div>
      <div class="warp row">
        <div class="key alignCenter">会员卡</div>
        <div class="value alignCenter">{{vipList.cardName}}{{vipList.discount*10}}折卡</div>
      </div>
      <div class="warp row">
        <div class="key alignCenter">可用余额</div>
        <div class="value alignCenter">{{vipList.wallet}}</div>
      </div>
      <div class="warp row">
        <div class="key alignCenter"></div>
        <div class="activity alignCenter">
          <div
            :class="activityIndex == index?'activityItem2':'activityItem'"
            @click="clickItem(index,item)"
            v-for="(item,index) in activityArray"
            :key="index"
          >充值{{item.rechargeMoney}}送{{item.handselMoney}}</div>
        </div>
      </div>
      <div class="warp row">
        <div class="key alignCenter">充值金额</div>
        <div class="value alignCenter">
          <input placeholder="请输入充值金额" v-model="payMoney" type="number" />
          <div class="unit">元</div>
        </div>
      </div>
      <div class="warp row">
        <div class="key alignCenter"></div>
        <div class="value2 alignCenter">
          <el-button type="primary" @click="confirmRecharge">现金充值</el-button>
          <el-button type="primary" @click="scanRecharge">扫码充值</el-button>
          <el-button type="primary" @click="handleWorkCharge">标记收款</el-button>
        </div>
      </div>
    </div>

    <!-- 现金收款 -->
    <el-dialog
      title="现金充值"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <div class="bjPay">
        <div class="bjPay-price center">应收金额：￥{{payMoney}}</div>
        <div class="bjPay-price center" style="margin-top:0">找零：￥{{giveChange}}</div>
        <div class="row">
          <el-input
            placeholder="实收金额"
            @input="inputWrite"
            type="number"
            v-model="amountReceived"
            style="margin: 10px auto; width: 300px;"
          ></el-input>
        </div>
        <div class="center buttonGroup">
          <el-button type="primary" @click="writeRemark" plain>备注</el-button>
          <el-button type="primary" @click="cancelPay" plain>取消收款</el-button>
          <el-button type="primary" @click="cashPay" :disabled="comfirmDisable">确认收款</el-button>
        </div>
      </div>
    </el-dialog>
    
    <!-- 扫码收款 -->
    <el-dialog
      title="扫码充值"
      :visible.sync="dialogVisible1"
      width="30%"
      :before-close="handleClose1">
      <div class="bjPay">
        <div class="bjPay-price center">应收金额：￥{{payMoney}}</div>
        <div class="center codePay-img">
          <img src="../../assets/icon/smfk.png" alt />
        </div>
        <div class="bjPay-markedWords center">请使用扫码枪扫描付款码</div>
        <div class="row" style="margin: 10px auto;">
          <el-input placeholder="付款码" v-model="barCode" ref="getFocus"></el-input>
        </div>
        <div class="center buttonGroup">
          <el-button type="primary" @click="writeRemark" plain>备注</el-button>
          <el-button type="primary" @click="cancelPay" plain>取消收款</el-button>
          <el-button type="primary" :disabled="autoPay" @click="codePay">{{autoPay?'自动收款':'确认收款'}}</el-button>&nbsp;&nbsp;&nbsp; &nbsp;自动收款开关：
          <el-switch v-model="autoPay"></el-switch>
        </div>
      </div>
    </el-dialog>

    <!-- 标记收款 -->
    <el-dialog
      title="标记收款"
      :visible.sync="dialogVisible2"
      width="40%"
      :before-close="handleClose2">
      <div class="bjPay">
        <div class="bjPay-price center">应收金额：￥{{payMoney}}</div>
        <div class="bjPay-markedWords center">如你已使用以下方式向消费者收款，可以选择对应的标记收款</div>
        <div class="row center">
          <div
            @click="clickPayType(1)"
            :class="payTypeIndex == 1?'bjPay-payType2':'bjPay-payType'"
            class="row center"
          >
            <img
              class="typeIcon2"
              v-if="payTypeIndex == 1"
              src="../../assets/icon/topRight.png"
              alt
            />
            <img class="typeIcon" src="../../assets/icon/zypossk.png" alt />
            <div>
              <div>自有POS刷卡</div>
              <div class="text1">标记收款</div>
            </div>
          </div>
          <div
            @click="clickPayType(2)"
            :class="payTypeIndex == 2?'bjPay-payType2':'bjPay-payType'"
            class="row center"
          >
            <img
              class="typeIcon2"
              v-if="payTypeIndex == 2"
              src="../../assets/icon/topRight.png"
              alt
            />
            <img class="typeIcon" src="../../assets/icon/zywxzf.png" alt />
            <div>
              <div>自有微信支付</div>
              <div class="text1">标记收款</div>
            </div>
          </div>
          <div
            @click="clickPayType(3)"
            :class="payTypeIndex == 3?'bjPay-payType2':'bjPay-payType'"
            class="row center"
          >
            <img
              class="typeIcon2"
              v-if="payTypeIndex == 3"
              src="../../assets/icon/topRight.png"
              alt
            />
            <img class="typeIcon" src="../../assets/icon/zyzfb.png" alt />
            <div>
              <div>自有支付宝</div>
              <div class="text1">标记收款</div>
            </div>
          </div>
        </div>
        <div class="bjPay-markedWords center">标：标记收款禁用作记账，钱款不计入你的钱如潮店铺余额，你需要自行向消费者确认已经支付和收款到账。</div>
        <div class="center buttonGroup">
          <el-button type="primary" @click="writeRemark" plain>备注</el-button>
          <el-button type="primary" @click="cancelPay" plain>取消收款</el-button>
          <el-button type="primary" @click="writePay">确认收款</el-button>
        </div>
      </div>
    </el-dialog>
    
  </div>

  <div v-show="pageType == 2">
    <div class="rc-title flex-between">
      <div>收款</div>
      <div class="back" @click="back(false)">X</div>
    </div>
    <div class="contents">
      <div class="icon">
        <img src="../../assets/icon/payResult.png" alt />
      </div>
      <div class="text1">收款成功</div>
      <div class="text2">￥{{orderList.gainMoney}}</div>
      <div class="text4">请领取小票，期待下次光临</div>

      <div class="buttonGroup" style="margin-top: 15px;">
        <el-button type="primary" @click="print" plain>重打小票</el-button>
        <el-button type="primary" @click="back(false)">返回</el-button>
      </div>
    </div>
  </div>

</div>
</template>
<script>
import { shopMemberList, activityList, shopMemberRecharge, toOrderDetail, userPayScan, Order_payResult } from "../api";
export default {
  data() {
    return {
      loading: false, //扫码充值loading
      phoneNum: "",
      userList: "",
      shopInformation: "",
      vipList: [],
      activityArray: [],
      activityIndex: null,
      payMoney: 0,
      codeMsg: "",
      mallOrderId:'',
      dialogVisible: false,
      amountReceived: "",
      giveChange: 0,
      dialogVisible1: false,
      barCode: "",
      autoPay: false, //自动收款开关
      intervalNum: 0, //循环次数
      intervalStart: false, //开始循环
      dialogVisible2: false,
      payTypeIndex: 1, //1自有pos 2微信 3支付宝
      comfirmDisable: false,
      orderList: [],
      pageType: 1,
      orderMark: ""
    };
  },

  watch: {
    barCode: function(oldValue, newValue) {
      console.log(this.barCode, "code改变");
      if (this.barCode.length == 18) {
        if (this.autoPay) {
          this.codePay();
        }
        this.$forceUpdate() 
        // console.log('123213123',this.loading)
        //  this.loading = false;
        // console.log('123213123',this.loading)
        document.onkeydown = "";
      }
    }
  },

  // directives: {
  // // 注册一个局部的自定义指令 v-focus
  //   focus: {
  //     // 指令的定义
  //     inserted: function (el) {
  //       // 聚焦元素
  //       el.querySelector('input').focus()
  //     }
  //   }
  // },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.phoneNum = this.$route.query.phoneNum;
    this.shopMemberList(this.$route.query.phoneNum);
  },

  methods: {
    // 标记收款确定
    writePay() {
      this.dialogVisible2 = false
      if (this.intervalStart) {
        //判断是否已开始循环
        this.$message.error("十秒内只能支付一次");
        return;
      }
      this.intervalStart = true;
      //循环为解决创建订单异步问题，防止拿不到订单号
      var interval = setInterval(res => {
        // console.log(this.intervalNum, "fail");
        this.intervalNum++;
        if (this.intervalNum > 10) {
          clearInterval(interval);
          this.intervalStart = false;
          this.intervalNum = 0;
        }
        console.log("success");
        clearInterval(interval);
        this.intervalStart = false;
        this.loading = true
        var receiptType;
        if (this.payTypeIndex == 1) {
          receiptType = 7;
        } else if (this.payTypeIndex == 2) {
          receiptType = 5;
        } else if (this.payTypeIndex == 3) {
          receiptType = 6;
        }
        shopMemberRecharge({
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          payMoney: this.payMoney,
          shopMemberId: this.vipList.shopMemberId,
          receiptType: receiptType,
          orderMark: this.orderMark
        })
          .then(res => {
            if (res.code == 1) {
              this.loading = false;
              this.shopMemberList(this.phoneNum);
              this.$message({
                message: "充值成功",
                type: "success"
              });
              this.pageType = 2
              this.payMoney = null;
              this.activityIndex = null;
              this.toOrderDetail(res.data.mallOrderId)
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(function(error) {
            this.$message.error(res.msg);
          });
      }, 1000);
    },
    handleWorkCharge() {
      if (this.payMoney <= 0) {
        this.$message.error("请填写正确充值金额");
        return;
      }
      this.dialogVisible2 = true
      this.payMoney = Number(this.payMoney).toFixed(2)
    },
    clickPayType(index) {
      this.payTypeIndex = index;
    },
    // 取消标记收款
    handleClose2() {
      this.dialogVisible2 = false
    },
    // 取消扫码付款
    handleClose1() {
      this.dialogVisible1 = false
    },
    // 取消充值
    cancelPay() {
      this.dialogVisible = false
      this.dialogVisible1 = false
      this.dialogVisible2 = false
    },
    handleClose() {
      this.dialogVisible = false
    },
    inputWrite(e) {
      this.giveChange = (e - this.payMoney).toFixed(2);
      if (this.giveChange < 0) {
        this.comfirmDisable = true
      } else {
        this.comfirmDisable = false
      }
    },
    writeRemark() {
      this.$prompt("请输入备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          this.$message({
            type: "success",
            message: "已备注: " + value
          });
          this.orderMark = value;
        })
        .catch(() => {});
    },
    // 现金充值
    cashPay() {
      if (this.intervalStart) {
        //判断是否已开始循环
        this.$message.error("十秒内只能支付一次");
        return;
      }
      this.intervalStart = true;
      var interval = setInterval(res => {
        // console.log(this.intervalNum, "fail");
        this.intervalNum++;
        if (this.intervalNum > 10) {
          clearInterval(interval);
          this.intervalStart = false;
          this.intervalNum = 0;
        }
        console.log("success");
        clearInterval(interval);
        this.intervalStart = false;
        shopMemberRecharge({
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          payMoney: this.payMoney,
          shopMemberId: this.vipList.shopMemberId,
          receiptType: 1,
          giveChange: this.giveChange,
          orderMark: this.orderMark
        })
        .then(res => {
          if (res.code == 1) {
            this.dialogVisible = false
            this.shopMemberList(this.phoneNum);
            this.$message({
              message: "充值成功",
              type: "success"
            });
            this.pageType = 2
            this.amountReceived = null
            this.payMoney = null;
            this.activityIndex = null;
            this.toOrderDetail(res.data.mallOrderId)
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          //   alert("商品接口网络错误，不能访问");
          //   console.log(error);
        })
      }, 1000);
    },
    //扫码付款
    Pay_userPayScan() {
      if (this.intervalStart) {
        //判断是否已开始循环
        this.$message.error("十秒内只能支付一次");
        return;
      }
      this.intervalStart = true;
      this.loading = true;
      var interval = setInterval(res => {
        // console.log(this.intervalNum, "fail");
        this.intervalNum++;
        if (this.intervalNum > 10) {
          clearInterval(interval);
          this.intervalStart = false;
          this.intervalNum = 0;
        }
        console.log("success");
        clearInterval(interval);
        userPayScan({
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          mallOrderId: this.mallOrderId, //订单id
          auth_code: this.barCode //收款码
        })
          .then(res => {
            if (res.code == 1) {
              console.log(res.code, 1);
              this.Order_payResult(this.mallOrderId);
              this.intervalStart = false;
              this.mallOrderId = ''
              this.payMoney = null;
              this.activityIndex = null;
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(function(error) {});
      }, 1000);
    },
    //扫码充值
    codePay() {
      this.loading = true;
      shopMemberRecharge({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        payMoney: this.payMoney,
        shopMemberId: this.vipList.shopMemberId,
        receiptType: 2,
        orderMark: this.orderMark
      })
        .then(res => {
          if (res.code == 1) {
            this.mallOrderId = res.data.mallOrderId;
            this.loading = false;
            this.Pay_userPayScan()
            this.dialogVisible1 = false
            this.payMoney = null;
            this.activityIndex = null;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          //   alert("商品接口网络错误，不能访问");
          //   console.log(error);
        });
    },
    //扫码充值弹框
    scanRecharge() {
      if (this.payMoney <= 0) {
        this.$message.error("请填写正确充值金额");
        return;
      }
      this.dialogVisible1 = true
      this.payMoney = Number(this.payMoney).toFixed(2)
      this.$nextTick( () =>{
        this.$refs.getFocus.focus()
      })
      // shopMemberRecharge({
      //   sessionId: this.userList.sessionId,
      //   userId: this.userList.id,
      //   payMoney: this.payMoney,
      //   shopMemberId: this.vipList.shopMemberId,
      //   receiptType: 2
      // })
      //   .then(res => {
      //     if (res.code == 1) {
      //       document.onkeydown = e => {
      //         console.log(e, "onkeydown");
      //         var b;
      //         if (this.codeMsg.length == 18 && e.key != "Enter") {
      //           this.codeMsg = "";
      //         }
      //         if (e.key != "Enter") {
      //           this.codeMsg += e.key;
      //         }
      //       };
      //       this.mallOrderId = res.data.mallOrderId;
      //       this.loading = true;
      //     } else if (res.code == 2) {
      //       this.$message.error(res.msg);
      //       this.$router.push("/");
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   })
      //   .catch(function(error) {
      //     //   alert("商品接口网络错误，不能访问");
      //     //   console.log(error);
      //   });
    },
    // 现金收款弹框
    confirmRecharge() {
      if (this.payMoney <= 0) {
        this.$message.error("请填写正确充值金额");
        return;
      }
      this.dialogVisible = true
      this.payMoney = Number(this.payMoney).toFixed(2)
      this.giveChange = Number(this.giveChange).toFixed(2)
      // this.amountReceived = Number(this.payMoney).toFixed(2)
      // this.$confirm("确认充值会员卡吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // }).then(() => {
      //   shopMemberRecharge({
      //     sessionId: this.userList.sessionId,
      //     userId: this.userList.id,
      //     payMoney: this.payMoney,
      //     shopMemberId: this.vipList.shopMemberId,
      //     receiptType: 1
      //   })
      //     .then(res => {
      //       if (res.code == 1) {
      //         this.shopMemberList(this.phoneNum);
      //         this.$message({
      //           message: "充值成功",
      //           type: "success"
      //         });
      //         this.payMoney = null;
      //         this.activityIndex = null;
      //       } else if (res.code == 2) {
      //         this.$message.error(res.msg);
      //         this.$router.push("/");
      //       } else {
      //         this.$message.error(res.msg);
      //       }
      //     })
      //     .catch(function(error) {
      //       //   alert("商品接口网络错误，不能访问");
      //       //   console.log(error);
      //     });
      // });
    },  
    //轮询订单
    Order_payResult(mallOrderId, num) {
      Order_payResult({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        mallOrderId: mallOrderId
      }).then(res => {
        if (!num) {
          num = 0;
          num = num + 1;
        } else {
          num = num + 1;
        }
        console.log("轮询", num);
        if (num >= 10) {
          this.$message.error("支付失败");
          this.loading = false;
          return;
        }
        this.orderList = res.data;
        console.log(this.orderList, 'this.orderList轮询')
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "支付成功"
          });
          this.loading = false;
          this.shopMemberList(this.phoneNum);
          this.pageType = 2
          this.print()
          this.clearAll();
        } else {
          setTimeout(() => {
            this.Order_payResult(mallOrderId, num);
          }, 3000);
        }
      });
    },
    clearAll() {
      this.payList = {
        orderMark: "",
        payMoney: 0,
        giveChange: 0,
        amountReceived: 0,
        phoneNum: "",
        barCode: ""
      }
    },
    clickItem(index, item) {
      this.payMoney = item.rechargeMoney;
      this.activityIndex = index;
    },
    back(a) {
      if (a) {
        this.$router.push("/cashierOrder/cashierOrderHome");
        return;
      }
      this.$router.go(-1);
    },
    activityList(shopMemberCardId) {
      activityList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        shopMemberCardId: shopMemberCardId,
        row: 9999
      })
        .then(res => {
          //   console.log(res.data, "活动列表");
          if (res.code == 1) {
            var arr = res.data[0].itemContent;
            // console.log(JSON.parse(arr))
            this.activityArray = JSON.parse(arr);
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else if (res.code == -1) {
          }
        })
        .catch(function(error) {
          //   alert("商品接口网络错误，不能访问");
          //   console.log(error);
        });
    },
    shopMemberList(phone11Num) {
      shopMemberList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        phone11Num: phone11Num
      })
        .then(res => {
          // console.log(res.data, "获取商品列表");
          if (res.code == 1) {
            this.vipList = res.data[0];
            this.$store.state.offers.vipIfm = res.data[0];
            this.activityList(res.data[0].shopMemberCardId);
            console.log(this.vipList, 'this.vipList');
            this.$forceUpdate()
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else if (res.code == -1) {
          }
        })
        .catch(function(error) {
          //   alert("商品接口网络错误，不能访问");
          //   console.log(error);
        });
    },
    // 获取打印信息
    toOrderDetail(mallOrderId) {
      toOrderDetail({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        mallOrderId: mallOrderId
      })
      .then(res=> {
        console.log(res, 'res')
        this.orderList = res.data
        this.print()
      })
    },
    print() {
      let orderList = this.orderList
      var template_html = `
      <form id="from">
        <div class="center column">
          <div class="center shopName boldFont">${this.shopInformation.shopName}</div>
        </div>
        <div class="content1">
          <div>单号：${orderList.tradeNo}</div>
          <div>时间：${orderList.payTime}</div>
          <div>收银：${orderList.cashierUserFullName}</div>
          <div class="br"></div>
        </div>
           <div>
        <div>会员卡充值</div>
        <div class="flex-between">
          <div>充值金额：</div>
          <div>${orderList.gainMoney.toFixed(2)}</div>
        </div>
      `;
      template_html += `
       </div>
        <div class="br"></div>
      </div>
      <div>
        <div class="flex-between">
          <div>支付方式：</div>
          <div>${
            orderList.payInterfacePartyType == 0
              ? "未知"
              : orderList.payInterfacePartyType == 1
              ? "系统"
              : orderList.payInterfacePartyType == 2
              ? "支付宝"
              : orderList.payInterfacePartyType == 3
              ? "微信"
              : orderList.payInterfacePartyType == 4
              ? "银联支付"
              : orderList.payInterfacePartyType == 5
              ? "百付宝"
              : orderList.payInterfacePartyType == 5
              ? "百付宝"
              : orderList.payInterfacePartyType == 6
              ? "QQ钱包"
              : orderList.payInterfacePartyType == 7
              ? "京东钱包"
              : orderList.payInterfacePartyType == 8
              ? "刷卡记账"
              : orderList.payInterfacePartyType == 9
              ? "现金记账"
              : orderList.payInterfacePartyType == 10
              ? "会员卡支付"
              : orderList.payInterfacePartyType == 11
              ? "线下收款"
              : orderList.payInterfacePartyType == 12
              ? "支付宝记账"
              : orderList.payInterfacePartyType == 13
              ? "微信记账"
              : ""
          }</div>
        </div>
        <div class="flex-between">
          <div>应付：</div>
          <div>${orderList.gainMoney.toFixed(2)}</div>
        </div>
        <div class="flex-between boldFont" >
          <div class="">实付：</div>
          <div>${
            orderList.giveChange
              ? (orderList.giveChange + orderList.gainMoney).toFixed(2)
              : orderList.gainMoney.toFixed(2)
          }</div>
        </div>`;
      if (orderList.payInterfacePartyType == 11 || orderList.payInterfacePartyType == 9) {
        if (orderList.giveChange) {
          template_html += `
         <div class="flex-between boldFont" >
           <div  class="">找零：</div>
           <div>${
            orderList.giveChange.toFixed(2)
           }</div>
         </div>`;
        }
      }
      template_html += `
        <div class="br"></div>
      </div>
      <div>
        <div class="flex-between">
          <div>买家：</div>
          <div>${orderList.buyerName ? orderList.buyerName : "匿名用户"}</div>
        </div>
        <div class="br"></div>
      </div>
      <div>
        <div class>店铺电话：${this.shopInformation.shopTel}</div>
        <div class>店铺地址：${this.shopInformation.shopAddress}</div>
      </div>
       `;
      template_html += `<style>
     .item {
        margin-top: 10px;
      }
      #from{
        font-size: 12px;
        padding-right:5px
      }
      .br{  
        border-bottom: 1px dashed  #000;
        margin: 10px 0;
      }
      .boldFont{
         font-size: 22px;
        font-weight: 600;
      }
      .shopName{
        margin-bottom:20px;
      
      }
      .center {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .row {
        display: flex;
        flex-direction: row;
      }
      
      .column {
        display: flex;
        flex-direction: column;
      }
      
      .justCenter {
        display: flex;
        justify-content: center;
      }
      
      .alignCenter {
        display: flex;
        align-items: center;
      }
      .flex-between {
        display: flex;
        justify-content: space-between;
      }</style>
      `;

      LODOP.PRINT_INIT("订单小票");
      LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", template_html);
      LODOP.SET_PRINT_PAGESIZE(3, 600, 40, "");
      // LODOP.PREVIEW(); //预览
      LODOP.PRINT(); //打印
    }
  }
};
</script>

<style>
     .item {
        margin-top: 10px;
      }
      #from{
        font-size: 12px;
        padding-right:5px
      }
      .br{  
        border-bottom: 1px dashed  #000;
        margin: 10px 0;
      }
      .boldFont{
         font-size: 22px;
        font-weight: 600;
      }
      .shopName{
        margin-bottom:20px;
      
      }
      .center {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .row {
        display: flex;
        flex-direction: row;
      }
      
      .column {
        display: flex;
        flex-direction: column;
      }
      
      .justCenter {
        display: flex;
        justify-content: center;
      }
      
      .alignCenter {
        display: flex;
        align-items: center;
      }
      .flex-between {
        display: flex;
        justify-content: space-between;
      }</style>
      `;

      LODOP.PRINT_INIT("订单小票");
      LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", template_html);
      LODOP.SET_PRINT_PAGESIZE(3, 600, 40, "");
      // LODOP.PREVIEW(); //预览
      LODOP.PRINT(); //打印
    }
  }
};
</script>
<style scoped>
.unit {
  position: absolute;
  right: 10px;
}
input {
  border: none !important;
  padding: 10px;
}
.activityItem2 {
  padding: 10px 8px;
  border: 1px solid #108ee9;
  color: #108ee9;
  font-size: 12px;
  border-radius: 2px;
  margin-right: 10px;
}
.activityItem {
  padding: 10px 8px;
  border: 1px solid #cccccc;
  color: #666666;
  font-size: 12px;
  border-radius: 2px;
  margin-right: 10px;
}
.content {
  padding: 50px;
}
.contents {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 100px;
  flex-direction: column;
}
.activity {
  height: 100%;
  /* width: 300px; */
  padding-left: 10px;
}
.key {
  height: 100%;
  width: 80px;
  color: #666666;
  text-align: right;
}
.value {
  height: 100%;
  width: 300px;
  border-bottom: 1px solid #eee;
  padding-left: 10px;
  position: relative;
}
.warp {
  height: 45px;
  margin-bottom: 20px;
  font-size: 14px;
  position: relative;
}
.back {
  cursor: pointer;
  color: gray;
  font-size: 20px;
}
.rc-title {
  /* background: #eeeeee; */
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(16, 142, 233, 1);
}
.bjPay-payType2 {
  height: 110px;
  width: 240px;
  border-radius: 3px;
  border: 1px solid rgba(51, 132, 249, 1);
  box-shadow: 0px 0px 16px 0px rgba(208, 208, 208, 0.4);
  position: relative;
  margin-top: 50px;
  margin-right: 26px;
  box-sizing: border-box;
  cursor: pointer;
}
.bjPay-payType {
  margin-top: 50px;
  height: 110px;
  width: 240px;
  margin-right: 26px;
  cursor: pointer;
}
.typeIcon2 {
  height: 25px;
  width: 25px;
  position: absolute;
  top: 0;
  right: 0;
}
.typeIcon {
  height: 40px;
  width: 40px;
  margin-right: 28px;
}
.bjPay-markedWords {
  margin-top: 20px;
  margin-bottom: 40px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(90, 93, 90, 1);
}
.text1 {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* margin-bottom: 25px; */
}
.text4 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* margin-bottom: 19px; */
  margin: 0 !important;
}
.text2 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* margin-bottom: 40px; */
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrderVipRecharge.vue